import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const IssueList = Loadable(
  lazy(() => import("features/issue/components/List"))
);
const Page = Loadable(lazy(() => import("features/issue/components/Page")));


const routes = {
  path: "issue",
  children: [
    { path: "", element: <IssueList /> },
    { path: "add", element: <Page /> },
    { path: "edit/:issueID?", element: <Page /> },
  ],
};

export default routes;
